<template>
    <div>
        <span v-if="!isEditing">
            <b-button v-if="hasPermission('triggers.edit')" variant="link" class="p-0 m-0 mx-2 float-right" size="sm" v-b-tooltip="`Bewerken`"
                      @click="openEditMode"
            >
                <small><font-awesome-icon icon="pencil" class="text-info"/></small>
            </b-button>
            <slot>
                <span v-html="nl2br(value)"/>
            </slot>
        </span>
        <span v-else>
            <b-textarea v-model="editableValue" size="sm" autofocus style="width:calc(100% - 40px);" class="d-inline-block" :disabled="isSaving" ref="editTextarea"
                        @focus="resizeTextarea"
            />
            <div style="width:40px;" class="float-right">
                <b-button variant="link" class="p-0 my0 mx-2" v-b-tooltip="`Opslaan`" :disabled="isSaving"
                          @click="saveAndCloseEditMode"
                >
                    <small><font-awesome-icon icon="floppy-disk" class="text-success"/></small>
                </b-button>
                <b-button variant="link" class="p-0 my0 mx-2" v-b-tooltip="`Annuleren`" :disabled="isSaving"
                          @click="cancelEditing"
                >
                    <small><font-awesome-icon icon="ban" class="text-danger"/></small>
                </b-button>
            </div>
        </span>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "TriggerTextFieldWithEdit",

    props: {
        value: {required: true},
        api: {required: true},
        field: {required: true},
    },

    data() {
        return {
            isEditing: false,
            isSaving: false,
            editableValue: '',
        }
    },

    computed: {

    },

    methods: {
        openEditMode() {
            this.isEditing = true;
            this.editableValue = this.value;
        },
        cancelEditing() {
            if (this.editableValue !== this.value && !confirm('Weet je zeker dat je je wijzigingen wilt weggooien?')) {
                return false;
            }

            this.isEditing = false;
        },
        saveAndCloseEditMode() {
            this.isSaving = true;
            let postData = {}
            postData[this.field] = this.editableValue;

            axios.patch(this.api, postData)
                .then(() => {
                    this.isEditing = false;
                    this.value = this.editableValue;
                    this.$emit('input', this.value)
                })
                .catch(e => {
                    this.$alert(`Fout bij het opslaan`, 'danger');
                })
                .finally(() => {
                    this.isSaving = false;
                })
        },
        resizeTextarea(event) {
            event.target.style.height = event.target.scrollHeight + "px";
        },
    },
}
</script>
